
import { Component, Provide, Vue, Watch, Ref } from 'vue-property-decorator';
import CourseLectureModal from './modals/CourseLecture.vue';
import axios from '../../plugins/axios.js';
import ExportCoursesLecturesModal from './modals/ExportCoursesLecturesModal.vue';

@Component({
    components: {
        CourseLectureModal,
        ExportCoursesLecturesModal,
    },
})
export default class CoursesLectures extends Vue {
    @Provide() private lecturesDate: any = new Date();
    @Provide() private lectures: any = {};
    @Provide() private originalLectures: any = {};
    @Provide() private selectedLecture: any = {};
    @Provide() private instructorOptions: any = [];
    @Provide() private advisorOptions: any = [];
    @Provide() private queriedCondition: any = {
        instructors: [],
        advisors: [],
    };
    @Ref() private readonly courseLectureModal;
    @Ref() private readonly exportCoursesLecturesModal;

    private openCourseLectureModal(lecture: any) {
        this.selectedLecture = lecture;
        this.courseLectureModal.$emit('open');
    }

    private created() {
        this.getLectures();
    }

    @Watch('lecturesDate')
    private getLectures() {
        this.clearFilterOptions();
        axios.get('/api/v1/courses-lectures', {
            lecturesDate: this.lecturesDate,
        }).then(({ lectures, instructors, advisors }) => {
            this.originalLectures = lectures;
            this.formattedLectures(lectures);
            this.instructorOptions = instructors;
            this.advisorOptions = advisors;
        }).catch((error) => {
            this.$message.error(error);
        });
    }

    private clearFilterOptions() {
        this.queriedCondition.advisors = [];
        this.queriedCondition.instructors = [];
        this.instructorOptions = [];
        this.advisorOptions = [];
    }

    private formattedLectures(lectures: any) {
        this.lectures = {};
        let courseDate = '';
        for (const lecture of lectures) {
            if (lecture.course_date !== courseDate) {
                courseDate = lecture.course_date;
                this.lectures[courseDate] = [];
            }
            this.lectures[courseDate].push(lecture);
        }
    }

    private filterLectures() {
        const lectures = this.originalLectures.filter((lecture: any) => {
            if (this.queriedCondition.instructors.length > 0 && !this.queriedCondition.instructors.includes(lecture.instructorId)) {
                return false;
            }
            if (this.queriedCondition.advisors.length > 0 && !this.queriedCondition.advisors.includes(lecture.advisorUid)) {
                return false;
            }
            return true;
        });
        this.formattedLectures(lectures);
    }

    private formattedDate(day) {
        return day.split('-').slice(1).join('-');
    }

    private countOfLecture(day) {
        if (this.lectures[day]) {
            return `(${this.lectures[day].length})`;
        }
        return '';
    }

    private openExportCoursesLecturesModal() {
        this.exportCoursesLecturesModal.$emit('open');
    }
}
